import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "../../../6729.css";



import image1 from "../../../images/Engine-car/synthetic/6501/pictures_FF6501-1_green_front_1200.jpg";
import image2 from "../../../images/Engine-car/synthetic/6501/pictures_FF6501-1_green_back_1200.jpg";
import image3 from "../../../images/Engine-car/synthetic/6501/pictures_FF6501-4_green_front_1200.jpg";
import image4 from "../../../images/Engine-car/synthetic/6501/pictures_FF6501-4_green_back_1200.jpg";
import image5 from "../../../images/Engine-car/synthetic/6501/pictures_FF6501-5_green_front_1200.jpg";
import image6 from "../../../images/Engine-car/synthetic/6501/pictures_FF6501-5_green_back_1200.jpg";

import image7 from "../../../images/Engine-car/synthetic/6501/pictures_FF6501-20_green_front_1200.jpg";
import image8 from "../../../images/Engine-car/synthetic/6501/pictures_FF6501-20_green_back_1200.jpg";

import image9 from "../../../images/Engine-car/synthetic/6501/pictures_FF6501-60_green_front_1200.jpg";
import image10 from "../../../images/Engine-car/synthetic/6501/pictures_FF6501-60_green_back_1200.jpg";

import image11 from "../../../images/Engine-car/synthetic/6501/pictures_FF6501-DR_green_front_1200.jpg";
import image12 from "../../../images/Engine-car/synthetic/6501/pictures_FF6501-DR_green_back_1200.jpg";

import image13 from "../../../images/Engine-car/synthetic/6501/pictures_FF6501-IBC_white_front_1200.jpg"
import image14 from "../../../images/Engine-car/synthetic/6501/pictures_FF6501-IBC_white_back_1200.jpg"

const images = [
  { src: image1, alt: "Front" },
  { src: image3, alt: "Back" },
  { src: image5, alt: "Front 4L" },
  { src: image7, alt: "Back 4L" },
  { src: image9, alt: "Back 4L" },


];

const packageSlides = [
  { images: [image1, image2] },
  { images: [image3, image4] },
  { images: [image5, image6] },
  { images: [image7, image8] },   // 1L   // 20L
  { images: [image9, image10] },  // 60L
  { images: [image11, image12] },
  { images: [image13, image14] }, // 208L
];

const TDS_URL = "https://www.fanfaro.de/create-pdf/18";

const SDS_FILES = [
  { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(BE).pdf" },
  { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(BG).pdf" },
  { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(CZ).pdf" },
  { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(DE).pdf" },
  { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(DK).pdf" },
  { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(EE).pdf" },
  { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(ES).pdf" },
  { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(FI).pdf" },
  { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(FR).pdf" },
  { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(GR).pdf" },
  { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(HR).pdf" },
  { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(HU).pdf" },
  { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(IE).pdf" },
  { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(IT).pdf" },
  { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(LT).pdf" },
  { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(LV).pdf" },
  { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(NO).pdf" },
  { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(PL).pdf" },
  { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(PT).pdf" },
  { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(RO).pdf" },
  { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(RU).pdf" },
  { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(SE).pdf" },
  { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(SI).pdf" },
  { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF6501_-_FANFARO 6501 TSE 5W-30_(SK).pdf" }
];

export default function ImageWithContent() {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showSDS, setShowSDS] = useState(false);

  const [packageIndex, setPackageIndex] = useState(0);
  const [imageIndex, setImageIndex] = useState(0);

  const slideInterval = useRef(null);
  const slideDuration = 4000;

  useEffect(() => {
    startSlideTimer();
    return () => clearInterval(slideInterval.current);
  }, []);

  const startSlideTimer = () => {
    slideInterval.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, slideDuration);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
    clearInterval(slideInterval.current);
    startSlideTimer();
  };

  const nextImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev + 1) % total);
  };

  const prevImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
  };

  return (
    <>
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: "32px",
        padding: "24px",
        fontFamily: "Arial",
      }}
    >


      {/* LEFT IMAGE CAROUSEL */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>
        

        {/* Amazon Button (external link) */}
        <a
          href="https://amzn.in/d/0fxcWU9v"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy on Amazon
          </button>
        </a>

      </div>




      {/* RIGHT CONTENT */}
      <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
        <h2>FANFARO TSE 5W-30 6501</h2>

        <p>
          Innovative universal premium ester-containing engine oil for modern gasoline and diesel engines with and without turbocharging, designed according to European car manufacturer requirements.
        </p>

        <p><strong>Product properties:</strong></p>

        <ul style={{ paddingLeft: "20px" }}>

          <li>Ester technology and synthetic base ensure efficient engine operation in all modes including cold start, urban driving, highway use, and frequent temperature changes.</li>
          <li>Synthetic ester base with modern additives preserves engine power throughout the entire oil replacement interval.</li>
          <li>Excellent anti-wear and anti-friction protection due to strong oil film and high pumpability, increasing engine life even in start-stop driving and cold starts.</li>
          <li>Improves fuel efficiency thanks to low HTHS viscosity and optimized anti-friction properties.</li>
          <li>High thermo-oxidative stability effectively resists oil aging.</li>
          <li>Strong washing and dispersing properties fight deposits and keep engine parts clean throughout the service interval.</li>
          <li>Suitable for gasoline and diesel engines in cars, light commercial vehicles, vans, and light trucks from European and other manufacturers.</li>
          <li>Recommended for engines of Daimler and VW vehicles that require additional oil specifications.</li>
          <li>Not suitable for heavy trucks and similar vehicles.</li>
        </ul>

        <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
          CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
        </p>

        {/* SPECIFICATIONS */}
        <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
          <div>
            <b>Specifications</b>
            <ul style={{ paddingLeft: "20px" }}>
              <li>SAE 5W-30</li>
              <li>API SN/CH-4</li>
              <li>ACEA A3/B4</li>
              {/* <li>API SL</li>
              <li>JASO MA/MA2</li> */}
            </ul>
          </div>


          <div>
            <b>Recommendation</b>
            <ul style={{ paddingLeft: "20px" }}>

              
              <li>VOLKSWAGEN 502 00</li>
              <li>VOLKSWAGEN 505 00</li>
              <li>VOLKSWAGEN 503 01</li>
              <li>VOLKSWAGEN 501 01</li>
              <li>MB 229.3</li>
              <li>MB 229.5</li>
              <li>BMW LL-98</li>
              <li>RENAULT RN0710</li>
              <li>RENAULT RN0700</li>
              <li>FORD WSS-M2C913-B</li>
            </ul>
          </div>

          <div>
            <b>PACKAGES:</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(0);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  1L (FF6501-1)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(1);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  4L (FF6501-4)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(2);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  5L (FF6501-5)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(3);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  20L (FF6501-20)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(4);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  60L (FF6501-60)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(5);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  208L (FF6501-DR)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(6);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  1000L (FF6501-IBC)
                </span>
              </li>

            </ul>
          </div>
          <div>
            <b>SDS & TDS</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSDS(true);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  📄 SDS
                </a>
              </li>

              <li>
                <a
                  href={TDS_URL}
                  target="_blank"
                  style={{ textDecoration: "none" }}>
                  🖨️ TDS
                </a>
              </li>

            </ul>
          </div>

        </div>



      </div>

      {/* MODAL */}
      {
        showModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 999,
            }}
          >
            <div
              style={{
                background: "#fff",
                padding: "20px",
                width: "500px",
                borderRadius: "8px",
                position: "relative",
              }}
            >

              <span
                onClick={() => setShowModal(false)}
                style={{
                  position: "absolute",
                  right: "15px",
                  top: "10px",
                  cursor: "pointer",
                  fontSize: "22px",
                }}
              >
                ✕
              </span>

              <img
                src={packageSlides[packageIndex].images[imageIndex]}
                alt="package"
                style={{
                  width: "100%",
                  maxHeight: "450px",
                  objectFit: "contain",
                }}
              />

              <div style={{ textAlign: "center", marginTop: "20px" }}>

                <button onClick={prevImage}>◀</button>

                <span style={{ margin: "0 15px" }}>
                  {imageIndex + 1} of {packageSlides[packageIndex].images.length}
                </span>

                <button onClick={nextImage}>▶</button>

              </div>

            </div>
          </div>
        )
      }

      {
        showSDS && (
          <div className="sds-overlay" onClick={() => setShowSDS(false)}>
            <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
              {/* Close Icon */}
              <button
                className="sds-close-icon"
                onClick={() => setShowSDS(false)}
                aria-label="Close SDS"
              >
                ×
              </button>

              <h3>SDS –  FANFARO TSE 5W-30 6501</h3>

              <div className="sds-grid">
                {SDS_FILES.map((file) => (
                  <a
                    key={file.code}
                    href={file.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {file.code}
                  </a>
                ))}
              </div>
            </div>
          </div>
        )
      }
    </div >

    <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
    </>
  );
}